export const getters = {
  agentFullName: (state) => {
    console.log(state.agent);
    const { firstName = "", lastName = "" } = state.agent ?? {};

    if (firstName || lastName) {
      return ((firstName || "") + " " + (lastName || "")).trim();
    }

    return null;
  },

  getUserId: (state) => {
    const { id } = state.userInfo ?? {};
    return id;
  },

  saleLoaded: (state) => {
    return state.sale.id;
  },
};
